export default __webpack_public_path__ + "static/media/gallery_03.dce897e3.jpg";